import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { OblastPublicResponse } from '../models';
// @ts-ignore
import { PageDokumentResponse } from '../models';
// @ts-ignore
import { PageVyzvaPublicResponse } from '../models';
// @ts-ignore
import { VyzvaPublicDetail } from '../models';
// @ts-ignore
import { VyzvaSpecificationPublicResponse } from '../models';
// @ts-ignore
import { VyzvaZmenyPoUzavretiResponse } from '../models';
// @ts-ignore
import { VyzvaZoppmPrazdnaPublicResponse } from '../models';
/**
 * PublicVyzvaApi - axios parameter creator
 * @export
 */
export const PublicVyzvaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * find single <dokument> for <plne-zenie> of <vyzva>
         * @summary get <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva: async (vyzvaId: string, dokumentId: string, previewToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva', 'vyzvaId', vyzvaId)
            // verify required parameter 'dokumentId' is not null or undefined
            assertParamExists('fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva', 'dokumentId', dokumentId)
            const localVarPath = `/public/vyzva/{vyzvaId}/plne-znenie/dokumenty/{dokumentId}/content`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)))
                .replace(`{${"dokumentId"}}`, encodeURIComponent(String(dokumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find single <dokument> for <priloha> of <vyzva>
         * @summary get <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva: async (vyzvaId: string, cisloPrilohy: number, dokumentId: string, previewToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva', 'vyzvaId', vyzvaId)
            // verify required parameter 'cisloPrilohy' is not null or undefined
            assertParamExists('fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva', 'cisloPrilohy', cisloPrilohy)
            // verify required parameter 'dokumentId' is not null or undefined
            assertParamExists('fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva', 'dokumentId', dokumentId)
            const localVarPath = `/public/vyzva/{vyzvaId}/prilohy/{cisloPrilohy}/dokumenty/{dokumentId}/content`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)))
                .replace(`{${"cisloPrilohy"}}`, encodeURIComponent(String(cisloPrilohy)))
                .replace(`{${"dokumentId"}}`, encodeURIComponent(String(dokumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find vyzva list public
         * @summary find vyzva list public
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFromListPublicVyzva: async (rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/vyzva`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rsql !== undefined) {
                localVarQueryParameter['rsql'] = rsql;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find list of <dokument> for <plne-zenie> of <vyzva>
         * @summary find <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDokumentyForPlneZnenieOfVyzvaPublicVyzva: async (vyzvaId: string, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('findDokumentyForPlneZnenieOfVyzvaPublicVyzva', 'vyzvaId', vyzvaId)
            const localVarPath = `/public/vyzva/{vyzvaId}/plne-znenie/dokumenty`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find list of <dokument> for <priloha> of <vyzva>
         * @summary find <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDokumentyForPrilohaOfVyzvaPublicVyzva: async (vyzvaId: string, cisloPrilohy: number, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('findDokumentyForPrilohaOfVyzvaPublicVyzva', 'vyzvaId', vyzvaId)
            // verify required parameter 'cisloPrilohy' is not null or undefined
            assertParamExists('findDokumentyForPrilohaOfVyzvaPublicVyzva', 'cisloPrilohy', cisloPrilohy)
            const localVarPath = `/public/vyzva/{vyzvaId}/prilohy/{cisloPrilohy}/dokumenty`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)))
                .replace(`{${"cisloPrilohy"}}`, encodeURIComponent(String(cisloPrilohy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find vyzva public detail
         * @summary find vyzva public detail
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailPublicVyzva: async (vyzvaId: string, previewToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('getDetailPublicVyzva', 'vyzvaId', vyzvaId)
            const localVarPath = `/public/vyzva/{vyzvaId}`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find vyzva zoppm prazdna by id
         * @summary find vyzva zoppm prazdna
         * @param {string} vyzvaId 
         * @param {'PO' | 'FO'} [example] 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmptyVyzvaPublicVyzva: async (vyzvaId: string, example?: 'PO' | 'FO', previewToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('getEmptyVyzvaPublicVyzva', 'vyzvaId', vyzvaId)
            const localVarPath = `/public/vyzva/{vyzvaId}/zoppm/prazdna`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (example !== undefined) {
                localVarQueryParameter['example'] = example;
            }

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find vyzva public oblast
         * @summary find vyzva public oblast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVyzvaOblastiPublicVyzva: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/vyzva/oblast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * find vyzva specification by id
         * @summary find vyzva specification
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVyzvaSpecificationPublicVyzva: async (vyzvaId: string, previewToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('getVyzvaSpecificationPublicVyzva', 'vyzvaId', vyzvaId)
            const localVarPath = `/public/vyzva/{vyzvaId}/spec`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (previewToken !== undefined && previewToken !== null) {
                localVarHeaderParameter['previewToken'] = String(previewToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get vyzva zmeny po uzavreti
         * @summary get vyzva zmeny po uzavreti
         * @param {string} vyzvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ziskajZmenyPoUzavretiPublicVyzva: async (vyzvaId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vyzvaId' is not null or undefined
            assertParamExists('ziskajZmenyPoUzavretiPublicVyzva', 'vyzvaId', vyzvaId)
            const localVarPath = `/public/vyzva/{vyzvaId}/zmeny-po-uzavreti`
                .replace(`{${"vyzvaId"}}`, encodeURIComponent(String(vyzvaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicVyzvaApi - functional programming interface
 * @export
 */
export const PublicVyzvaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicVyzvaApiAxiosParamCreator(configuration)
    return {
        /**
         * find single <dokument> for <plne-zenie> of <vyzva>
         * @summary get <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, dokumentId: string, previewToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, dokumentId, previewToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find single <dokument> for <priloha> of <vyzva>
         * @summary get <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, dokumentId: string, previewToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, dokumentId, previewToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find vyzva list public
         * @summary find vyzva list public
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllFromListPublicVyzva(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageVyzvaPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllFromListPublicVyzva(rsql, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find list of <dokument> for <plne-zenie> of <vyzva>
         * @summary find <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDokumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, previewToken, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find list of <dokument> for <priloha> of <vyzva>
         * @summary find <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDokumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, previewToken, page, size, sortBy, direction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find vyzva public detail
         * @summary find vyzva public detail
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailPublicVyzva(vyzvaId: string, previewToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VyzvaPublicDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailPublicVyzva(vyzvaId, previewToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find vyzva zoppm prazdna by id
         * @summary find vyzva zoppm prazdna
         * @param {string} vyzvaId 
         * @param {'PO' | 'FO'} [example] 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmptyVyzvaPublicVyzva(vyzvaId: string, example?: 'PO' | 'FO', previewToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VyzvaZoppmPrazdnaPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmptyVyzvaPublicVyzva(vyzvaId, example, previewToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find vyzva public oblast
         * @summary find vyzva public oblast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVyzvaOblastiPublicVyzva(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OblastPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVyzvaOblastiPublicVyzva(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * find vyzva specification by id
         * @summary find vyzva specification
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVyzvaSpecificationPublicVyzva(vyzvaId: string, previewToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VyzvaSpecificationPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVyzvaSpecificationPublicVyzva(vyzvaId, previewToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get vyzva zmeny po uzavreti
         * @summary get vyzva zmeny po uzavreti
         * @param {string} vyzvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ziskajZmenyPoUzavretiPublicVyzva(vyzvaId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VyzvaZmenyPoUzavretiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ziskajZmenyPoUzavretiPublicVyzva(vyzvaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicVyzvaApi - factory interface
 * @export
 */
export const PublicVyzvaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicVyzvaApiFp(configuration)
    return {
        /**
         * find single <dokument> for <plne-zenie> of <vyzva>
         * @summary get <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, dokumentId: string, previewToken?: string, options?: any): AxiosPromise<string> {
            return localVarFp.fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, dokumentId, previewToken, options).then((request) => request(axios, basePath));
        },
        /**
         * find single <dokument> for <priloha> of <vyzva>
         * @summary get <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} dokumentId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, dokumentId: string, previewToken?: string, options?: any): AxiosPromise<string> {
            return localVarFp.fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, dokumentId, previewToken, options).then((request) => request(axios, basePath));
        },
        /**
         * find vyzva list public
         * @summary find vyzva list public
         * @param {string} [rsql] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllFromListPublicVyzva(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageVyzvaPublicResponse> {
            return localVarFp.findAllFromListPublicVyzva(rsql, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * find list of <dokument> for <plne-zenie> of <vyzva>
         * @summary find <dokument> for <plne-zenie> of <vyzva>
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageDokumentResponse> {
            return localVarFp.findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, previewToken, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * find list of <dokument> for <priloha> of <vyzva>
         * @summary find <dokument> for <priloha> of <vyzva>
         * @param {string} vyzvaId 
         * @param {number} cisloPrilohy 
         * @param {string} [previewToken] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sortBy] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: any): AxiosPromise<PageDokumentResponse> {
            return localVarFp.findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, previewToken, page, size, sortBy, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * find vyzva public detail
         * @summary find vyzva public detail
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailPublicVyzva(vyzvaId: string, previewToken?: string, options?: any): AxiosPromise<VyzvaPublicDetail> {
            return localVarFp.getDetailPublicVyzva(vyzvaId, previewToken, options).then((request) => request(axios, basePath));
        },
        /**
         * find vyzva zoppm prazdna by id
         * @summary find vyzva zoppm prazdna
         * @param {string} vyzvaId 
         * @param {'PO' | 'FO'} [example] 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmptyVyzvaPublicVyzva(vyzvaId: string, example?: 'PO' | 'FO', previewToken?: string, options?: any): AxiosPromise<VyzvaZoppmPrazdnaPublicResponse> {
            return localVarFp.getEmptyVyzvaPublicVyzva(vyzvaId, example, previewToken, options).then((request) => request(axios, basePath));
        },
        /**
         * find vyzva public oblast
         * @summary find vyzva public oblast
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVyzvaOblastiPublicVyzva(options?: any): AxiosPromise<OblastPublicResponse> {
            return localVarFp.getVyzvaOblastiPublicVyzva(options).then((request) => request(axios, basePath));
        },
        /**
         * find vyzva specification by id
         * @summary find vyzva specification
         * @param {string} vyzvaId 
         * @param {string} [previewToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVyzvaSpecificationPublicVyzva(vyzvaId: string, previewToken?: string, options?: any): AxiosPromise<VyzvaSpecificationPublicResponse> {
            return localVarFp.getVyzvaSpecificationPublicVyzva(vyzvaId, previewToken, options).then((request) => request(axios, basePath));
        },
        /**
         * get vyzva zmeny po uzavreti
         * @summary get vyzva zmeny po uzavreti
         * @param {string} vyzvaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ziskajZmenyPoUzavretiPublicVyzva(vyzvaId: string, options?: any): AxiosPromise<VyzvaZmenyPoUzavretiResponse> {
            return localVarFp.ziskajZmenyPoUzavretiPublicVyzva(vyzvaId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicVyzvaApi - object-oriented interface
 * @export
 * @class PublicVyzvaApi
 * @extends {BaseAPI}
 */
export class PublicVyzvaApi extends BaseAPI {
    /**
     * find single <dokument> for <plne-zenie> of <vyzva>
     * @summary get <dokument> for <plne-zenie> of <vyzva>
     * @param {string} vyzvaId 
     * @param {string} dokumentId 
     * @param {string} [previewToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, dokumentId: string, previewToken?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).fetchContentOfDokumentForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, dokumentId, previewToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find single <dokument> for <priloha> of <vyzva>
     * @summary get <dokument> for <priloha> of <vyzva>
     * @param {string} vyzvaId 
     * @param {number} cisloPrilohy 
     * @param {string} dokumentId 
     * @param {string} [previewToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, dokumentId: string, previewToken?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).fetchContentOfDokumentForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, dokumentId, previewToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find vyzva list public
     * @summary find vyzva list public
     * @param {string} [rsql] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public findAllFromListPublicVyzva(rsql?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).findAllFromListPublicVyzva(rsql, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find list of <dokument> for <plne-zenie> of <vyzva>
     * @summary find <dokument> for <plne-zenie> of <vyzva>
     * @param {string} vyzvaId 
     * @param {string} [previewToken] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId: string, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).findDokumentyForPlneZnenieOfVyzvaPublicVyzva(vyzvaId, previewToken, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find list of <dokument> for <priloha> of <vyzva>
     * @summary find <dokument> for <priloha> of <vyzva>
     * @param {string} vyzvaId 
     * @param {number} cisloPrilohy 
     * @param {string} [previewToken] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sortBy] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId: string, cisloPrilohy: number, previewToken?: string, page?: number, size?: number, sortBy?: string, direction?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).findDokumentyForPrilohaOfVyzvaPublicVyzva(vyzvaId, cisloPrilohy, previewToken, page, size, sortBy, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find vyzva public detail
     * @summary find vyzva public detail
     * @param {string} vyzvaId 
     * @param {string} [previewToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public getDetailPublicVyzva(vyzvaId: string, previewToken?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).getDetailPublicVyzva(vyzvaId, previewToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find vyzva zoppm prazdna by id
     * @summary find vyzva zoppm prazdna
     * @param {string} vyzvaId 
     * @param {'PO' | 'FO'} [example] 
     * @param {string} [previewToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public getEmptyVyzvaPublicVyzva(vyzvaId: string, example?: 'PO' | 'FO', previewToken?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).getEmptyVyzvaPublicVyzva(vyzvaId, example, previewToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find vyzva public oblast
     * @summary find vyzva public oblast
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public getVyzvaOblastiPublicVyzva(options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).getVyzvaOblastiPublicVyzva(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * find vyzva specification by id
     * @summary find vyzva specification
     * @param {string} vyzvaId 
     * @param {string} [previewToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public getVyzvaSpecificationPublicVyzva(vyzvaId: string, previewToken?: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).getVyzvaSpecificationPublicVyzva(vyzvaId, previewToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get vyzva zmeny po uzavreti
     * @summary get vyzva zmeny po uzavreti
     * @param {string} vyzvaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicVyzvaApi
     */
    public ziskajZmenyPoUzavretiPublicVyzva(vyzvaId: string, options?: AxiosRequestConfig) {
        return PublicVyzvaApiFp(this.configuration).ziskajZmenyPoUzavretiPublicVyzva(vyzvaId, options).then((request) => request(this.axios, this.basePath));
    }
}
